export function WindowDesign ({ Class }) {
  return (
    <section className={Class}>

      <div className='rounded-full bg-[#979797] w-6 h-6 max-[480px]:w-5 max-[480px]:h-5'>

      </div>

      <div className='rounded-full bg-[#979797] w-6 h-6 max-[480px]:w-5 max-[480px]:h-5'>

      </div>

      <div className='rounded-full bg-[#f34e00] w-6 h-6 max-[480px]:w-5 max-[480px]:h-5'>

      </div>
    </section>
  )
}
